export default "__VITE_ASSET__5u8EH3oE__"